import { Injectable } from '@angular/core';
import { GLOBAL } from '../global';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClasificacionService {

  url:string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(public httpClient:HttpClient) {
    this.url = GLOBAL.URL_SIGAMOS + 'sicaClasificacion';
  }

  public getDataClasificacion():Observable<any>{
    return this.httpClient.get(this.url+'/getDataClasificacion/',this.httpOptions);
  }

  public getClasificacionByCodigo(codigo:string):any{
    return this.httpClient.get(this.url+'/getClasificacionByCodigo/' + codigo);
  }
}
